import { RootState } from '@src/redux/store'
import { prop, propOr } from 'ramda'
import { createSelector } from 'reselect'

import {
  CCLS_MODULE,
  CCLS_MODULES_FILTER,
  CCLS_MODULE_ALL,
  CCLS_MODULE_CREATE,
  CCLS_MODULE_LIST,
  GLOBAL_STATE,
} from '../constants/actionTypes'

const cclsModulesSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const cclsModuleSelector = createSelector(cclsModulesSelector, data => data[CCLS_MODULE])

export const cclsModuleCreateSelector = createSelector(cclsModulesSelector, data => data[CCLS_MODULE_CREATE])

export const cclsModuleListSelector = createSelector(cclsModulesSelector, data => data[CCLS_MODULE_LIST])

export const cclsModuleAllSelector = createSelector(cclsModulesSelector, data => data[CCLS_MODULE_ALL])

export const cclsModulesFilter = createSelector(cclsModulesSelector, data => data[CCLS_MODULES_FILTER])

export const cclsModuleAllOptionsSelector = createSelector(cclsModuleAllSelector, selected => {
  return {
    loading: selected.loading,
    error: selected.error,
    options: Array.isArray(selected.data)
      ? selected.data.map(item => ({
          label: `${propOr('', 'title', item)} (${propOr('', 'semester_title', item)})`,
          value: item.id,
          isAuthorized: prop('authorized', item),
        }))
      : [],
  }
})
